module.exports = __webpack_public_path__ + "img/inhalt_pic.776a55ca.png";